import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiCpu, FiBarChart2, FiSettings, FiTrendingUp, FiDatabase, FiZap } from "react-icons/fi";
import HeroBanner from "../components/HeroBanner";
import SectionWrapper from "../components/SectionWrapper";
import aiHero from "../assets/ai-hero.jpg";

const solutions = [
  { icon: FiBarChart2, title: "Business Intelligence Dashboards", desc: "Real-time interactive dashboards that transform raw data into actionable business insights." },
  { icon: FiCpu, title: "AI-Based Recommendation Systems", desc: "Machine learning models that personalize user experiences and drive engagement." },
  { icon: FiSettings, title: "Process Automation", desc: "Automate repetitive tasks and workflows to reduce costs and increase operational efficiency." },
  { icon: FiTrendingUp, title: "Predictive Analytics", desc: "Forecast trends, customer behavior, and market changes with advanced analytics models." },
  { icon: FiDatabase, title: "Data Pipeline Engineering", desc: "Build robust ETL pipelines for data collection, transformation, and warehouse management." },
  { icon: FiZap, title: "RPA Solutions", desc: "Robotic Process Automation to streamline operations across departments." },
];

const AIDataAutomation = () => {
  return (
    <>
      <HeroBanner
        image={aiHero}
        title="AI, Data & Automation"
        subtitle="Leverage data intelligence, dashboards, and automation to reduce costs and increase efficiency."
      />

      <SectionWrapper>
        <div className="text-center mb-12">
          <h2 className="section-title mb-4">Our <span className="text-primary">Solutions</span></h2>
          <p className="section-subtitle mx-auto">Transform your business with intelligent automation and data-driven decision making.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {solutions.map((s, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="card-hover">
              <s.icon className="w-10 h-10 text-primary mb-4" />
              <h3 className="font-montserrat font-bold text-lg mb-2">{s.title}</h3>
              <p className="text-muted-foreground font-roboto text-sm">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-primary text-primary-foreground text-center">
        <h2 className="text-3xl md:text-4xl font-montserrat font-bold mb-4">Ready to Automate?</h2>
        <p className="text-primary-foreground/80 font-roboto text-lg mb-8 max-w-2xl mx-auto">Let us help you leverage AI and data for smarter decisions.</p>
        <Link to="/contact" className="btn-hero-outline">Get Started</Link>
      </SectionWrapper>
    </>
  );
};

export default AIDataAutomation;
